import { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, Route, Routes } from "react-router-dom";
import { DigitalCard } from "./digitalCard";
import { Verifyauth } from "./helpers/verify";
import { Login } from "./auth/login";
import { KatamTest } from "./user/katamTest";
import { PihtasTest } from "./user/pihtasTest";
import { PektaForm } from "./user/pektaForm";
import { PektaForm2 } from "./user/pektaForm2";
import { PektaForm3 } from "./user/pektaForm3";
import { PektaForm4 } from "./user/pektaForm4";
import { PektaForm5 } from "./user/pektaForm5";
import { PektaTest } from "./user/pektaTest";
import { Profile } from "./profile";
import { Register } from "./auth/register";
import { VerifyEmail } from "./auth/verifyEmail";
import { PermohonanPihtas } from "./user/permohonanPihtas";
import { PembaharuanKad } from "./user/pembaharuanKad";
import PrivateRoutes from "./auth/privateroutes";
import DynamicPage from "./user/pektaParent";
import KadRoutes from "./auth/kadroutes";
import TestRoutes from "./auth/testRoutes";
import Maintenance from "./maintanance";
import {
  resetUjianSettings,
  setUjianSettings,
} from "./helpers/maintenanceSettings";

function AppRoutes() {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [maintenanceTitle, setMaintenanceTitle] = useState(null);
  const [maintenanceWording, setMaintenanceWording] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/maintenance`)
      .then((response) => {
        const attributes = response.data?.data?.attributes;

        setMaintenanceMode(Boolean(attributes?.system_maintenance));
        setMaintenanceTitle(attributes?.maintenance_title ?? null);
        setMaintenanceWording(attributes?.maintenance_wording ?? null);
        setUjianSettings(attributes ?? {});
      })
      .catch((error) => {
        console.error("Maintenance API error:", error);
        setMaintenanceMode(false);
        resetUjianSettings();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#f5f5f5] text-gray-700">
        Memuatkan...
      </div>
    );
  }

  return (
    <Routes>
      {maintenanceMode ? (
        <>
          <Route
            path="*"
            element={
              <Maintenance
                title={maintenanceTitle}
                wording={maintenanceWording}
              />
            }
          />
        </>
      ) : (
        <>
          <Route element={<PrivateRoutes />} path="/">
            <Route element={<Profile />} path="/myprofile" />
            <Route element={<KadRoutes />}>
              <Route path="/kad-tauliah-katam" element={<DigitalCard />} />
            </Route>
            <Route element={<TestRoutes />}>
              <Route path="/pekta-test" element={<PektaTest />} />
              <Route path="/katam-test" element={<KatamTest />} />
              <Route path="/pihtas-test" element={<PihtasTest />} />
            </Route>
            <Route path="/pihtas-application" element={<PermohonanPihtas />} />
            <Route path="/katam-application" element={<PembaharuanKad />} />
            <Route path="/pekta-application" element={<DynamicPage />} />
            <Route element={<Login />} path="/" />
          </Route>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify_auth" element={<Verifyauth />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
}

export default AppRoutes;
